import { ICONS, IconName } from '../lib/icons'

interface Props {
  name: IconName
  size?: number
  className?: string
}

/**
 * The icon bodies are trusted, hand-authored constants from our own module —
 * never user input — so injecting them is safe and keeps a single icon set
 * shared with the plain-DOM floating window.
 */
export function Icon({ name, size = 16, className }: Props) {
  return (
    <svg
      className={`ico${className ? ` ${className}` : ''}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: ICONS[name] }}
    />
  )
}
